// Master translation file, pt-BR (Brazilian Portuguese)
// All other language files must mirror every key in this file.

export interface Translations {
  nav: {
    dashboard: string; forecast: string; birthChart: string; synastry: string;
    questions: string; astromatch: string; tarot: string; lenormand: string; numerology: string;
    iChing: string; dreamJournal: string; moonPhases: string; agenda: string;
    retrograde: string; eclipses: string; astroPet: string;
    astroCoach: string; startAstral: string; empresas: string; astrocartografia: string;
    wallet: string; readings: string; settings: string; signOut: string;
    quiromancy: string; vedicAstrology: string;
    humanDesign: string; blog: string; pricing: string;
  };
  credits: { questions: string; synastry: string; astromatch: string };
  home: {
    heroBadge: string; heroHeadline1: string; heroHeadline2: string;
    heroSubheadline: string; heroCta1: string; heroCta2: string;
    heroSocialProof: string; heroScrollHint: string;
    signForecastTitle: string; signForecastSubtitle: string;
    forecastToday: string; forecastWeek: string; forecastMonth: string;
    consultingStars: string; starsMoving: string;
    seeFullForecast: string; featureTitle: string; featureSubtitle: string;
    startFree: string;
    feat: {
      birthChartTitle: string; birthChartDesc: string; birthChartBadge: string;
      forecastTitle: string; forecastDesc: string;
      synastryTitle: string; synastryDesc: string; synastryBadge: string;
      questionsTitle: string; questionsDesc: string;
      astromatchTitle: string; astromatchDesc: string; astromatchBadge: string;
      moreTitle: string; moreDesc: string;
    };
    premiumBadge: string; premiumTitle1: string; premiumTitle2: string;
    premiumDesc: string; premiumF1: string; premiumF2: string; premiumF3: string;
    premiumF4: string; premiumF5: string; premiumF6: string;
    premiumPrice: string; premiumPer: string; premiumCta: string; premiumCancel: string;
    demoLabel1: string; demoSub1: string; demoLabel2: string; demoSub2: string;
    demoLabel3: string; demoSub3: string;
    servicesTitle: string; servicesSubtitle: string; servicesCta: string;
    badgePlan: string; badgeCredits: string; badgeAvulso: string; badgeNew: string;
    svc: {
      birthChart:  { name: string; subtitle: string; description: string };
      forecast:    { name: string; subtitle: string; description: string };
      synastry:    { name: string; subtitle: string; description: string };
      astroMatch:  { name: string; subtitle: string; description: string };
      astrocartografia: { name: string; subtitle: string; description: string };
      questions:   { name: string; subtitle: string; description: string };
      tarot:       { name: string; subtitle: string; description: string };
      lenormand:   { name: string; subtitle: string; description: string };
      numerology:  { name: string; subtitle: string; description: string };
      astroPet:    { name: string; subtitle: string; description: string };
      startAstral: { name: string; subtitle: string; description: string };
      retrograde:  { name: string; subtitle: string; description: string };
      eclipse:     { name: string; subtitle: string; description: string };
    };
  };
  auth: {
    email: string; password: string; confirmPassword: string;
    signIn: string; createAccount: string; forgotPassword: string;
    resetPassword: string; noAccount: string; hasAccount: string;
    orContinue: string; sendReset: string; backToLogin: string; checkEmail: string;
    signInTitle: string; createTitle: string;
    name: string; namePlaceholder: string;
    showPassword: string; hidePassword: string;
    createFree: string; createCta: string;
    agreeText: string; terms: string; privacyPolicy: string;
    biometricTitle: string; biometricDesc: string;
    biometricEnable: string; biometricSkip: string;
    continueGoogle: string; continueApple: string; oauthError: string;
  };
  common: {
    loading: string; error: string; retry: string; save: string; cancel: string;
    back: string; close: string; confirm: string; language: string;
  };
  dashboard: {
    cosmicBrief: string; consultingStars: string; starsMoving: string;
    completeBanner: string; completeBannerSub: string; addData: string;
    quickAccess: string; continueJourney: string; seeAll: string;
    greetingMorning: string; greetingAfternoon: string; greetingEvening: string;
    errorTitle: string; errorSubtitle: string; reload: string;
    suggBirthChartDesc: string; suggForecastTitle: string; suggForecastDesc: string;
    suggQuestionsDesc: string;
    premiumBadge: string; premiumWelcomeTitle: string; premiumWelcomeDesc: string; premiumClose: string;
    premiumStep1: string; premiumStep2: string; premiumStep3: string; premiumStep4: string; premiumStep5: string;
    renewalTitle: string; renewalToday: string; renewalTomorrow: string; renewalDays: string;
    renewalDesc: string; renewalCta: string;
    tierPremium: string;
    streakSingular: string; streakPlural: string;
    creditQuestionsSingular: string; creditQuestionsPlural: string; creditSynastry: string;
  };
  layout: {
    navSigns: string; navPlans: string; navBlog: string; navMyAccount: string;
    navSignIn: string; navStartFree: string;
    footerTagline: string; footerProduct: string; footerLegal: string;
    footerRights: string; footerMotto: string;
    footerSignos: string; footerBirthChart: string; footerSynastry: string;
    footerQuestions: string; footerPrivacy: string; footerTerms: string;
    footerLgpd: string;
    footerBrandTagline: string;
    footerServices: string; footerOracles: string;
    footerForecast: string; footerAstroMatch: string; footerAstrocartografia: string; footerStartAstral: string;
    footerTarot: string; footerIChing: string; footerNumerology: string; footerAstroPet: string;
    footerPrivacyFull: string; footerTermsFull: string; footerLgpdFull: string; footerCancellation: string;
    footerBusiness: string; footerContact: string;
    footerCopyright: string; footerDisclaimer: string;
    footerNewsletterDesc: string;
  };
  forecast: {
    title: string; emptyTitle: string; emptySubtitle: string; emptyCta: string;
    starsMoving: string;
    periodToday: string; periodWeek: string; periodMonth: string; periodYear: string;
    loadingDaily: string; loadingWeekly: string; loadingMonthly: string; loadingAnnual: string;
    skyNow: string;
    transitShort: string; transitMedium: string; transitMediumBadge: string;
    transitLong: string; transitLongBadge: string;
    transitApproaching: string; transitPeak: string; transitSeparating: string;
    transitLongTermChip: string; transitRetrograde: string;
    illumination: string;
    regenerateTitle: string; regenerateCta: string; stillThinking: string;
  };
  tabs: {
    home: string; forecast: string; questions: string; match: string;
    wallet: string; ariaLabel: string; map: string; atlas: string; profile: string;
    search: string; today: string; me: string;
  };
  pages: {
    onboarding: {
      stepOf: string; welcomeTitle: string; welcomeText: string; welcomeCta: string;
      birthDataTitle: string; birthDataDesc: string; birthDateLabel: string;
      birthTimeLabel: string; birthCityLabel: string; optional: string;
      youAreSign: string; backBtn: string; continueBtn: string; skipNow: string; skipSetup: string;
      firstReadingTitle: string; firstReadingDesc: string; firstReadingDesc2: string;
      previewLabel: string; previewFeat1Label: string; previewFeat1Desc: string;
      previewFeat2Label: string; previewFeat2Desc: string;
      previewFeat3Label: string; previewFeat3Desc: string;
      viewDashboard: string; upgradeTitle: string; upgradeDesc: string;
      upgradeF1: string; upgradeF2: string; upgradeF3: string; upgradeF4: string; upgradeF5: string;
      upgradeCta: string; upgradeFreeCta: string;
    };
    birthChart: {
      title: string; houseSystem: string; howToRead: string; calculating: string;
      planetPositions: string; planet: string; sign: string; degree: string; house: string;
      showAll: string; showLess: string; interpretation: string;
      calculateCta: string; retry: string; starsMoving: string;
      emptyTitle: string; emptySubtitle: string; emptyCta: string;
      guideTitle: string; guideCta: string;
    };
    synastry: {
      title: string; subtitle: string; partnerDataTitle: string;
      partnerNameLabel: string; partnerNamePlaceholder: string;
      partnerSignLabel: string; selectSign: string;
      partnerDateLabel: string; autoAnalyzeHint: string;
      analyzeCta: string; inviteText: string; generateLink: string;
      linkGenerated: string; copyBtn: string; compatibility: string;
      noCreditsMsg: string; buyLink: string; calculating: string;
      newAnalysis: string; errorMsg: string;
      emptyTitle: string; emptySubtitle: string; emptyCta: string;
      tabScore: string; tabAnalise: string; tabAspectos: string; tabCasas: string;
      tabComposto: string; tabDavison: string; tabTransitos: string; tabProgressoes: string;
      scoreLove: string; scoreCommunication: string; scoreValues: string;
      scoreLongTerm: string; scoreGrowth: string; scoreRoutine: string; scoreFamily: string;
    };
    tarot: {
      title: string; subtitle: string; restart: string;
      intentionMsg: string; loading: string; generalReading: string; reversed: string;
      spreadSingle: string; spreadSingleDesc: string;
      spreadThree: string; spreadThreeDesc: string;
      spreadHorseshoe: string; spreadHorseshoeDesc: string;
      spreadCeltic: string; spreadCelticDesc: string;
    };
    lenormand: {
      title: string; subtitle: string; restart: string;
      intentionMsg: string; loading: string; readingTitle: string;
      subscriptionRequired: string;
      spreadSingle: string; spreadSingleDesc: string;
      spreadThree: string; spreadThreeDesc: string;
      spreadFive: string; spreadFiveDesc: string;
      spreadNine: string; spreadNineDesc: string;
      questionLabel: string; questionPlaceholder: string; questionCta: string;
    };
    questions: {
      title: string; questionLabel: string; questionPlaceholder: string;
      showExamples: string; hideExamples: string; disclaimer: string;
      submitCta: string; submitLoading: string; answerTitle: string;
      historyTitle: string; noCreditsTitle: string; noCreditsDesc: string;
      loading: string; emptyTitle: string; emptySubtitle: string; emptyCta: string;
    };
    numerology: {
      title: string; subtitle: string; intro: string;
      calculateCta: string; calculating: string;
      lifePathLabel: string; destinyLabel: string; soulLabel: string; personalityLabel: string;
      newConsult: string; error: string;
      emptyTitle: string; emptySubtitle: string; emptyCta: string;
      tabSinteseGeral: string; tabCaminhoDeVida: string; tabDestino: string;
      tabAlma: string; tabPersonalidade: string;
    };
    iching: {
      title: string; subtitle: string; intro: string;
      questionLabel: string; questionPlaceholder: string;
      throwingCoins: string; consultCta: string;
      throwingMsg: string; interpretingMsg: string;
      hexagramLabel: string; transformsInto: string;
      newConsult: string; error: string;
    };
    dreamJournal: {
      title: string; subtitle: string;
      dreamLabel: string; dreamPlaceholder: string;
      interpretCta: string; loading: string;
      symbolsTitle: string; interpretationTitle: string; guidanceTitle: string;
      historyTitle: string; newEntry: string; error: string;
    };
    moonPhases: {
      title: string; subtitle: string; illuminated: string;
      upcomingPhases: string; ritualsFor: string;
    };
    humanDesign: {
      title: string; subtitle: string; intro: string;
      calculateCta: string; calculating: string;
      birthTimeWarning: string; birthTimeWarningDesc: string; addBirthTime: string;
      profileLabel: string; authorityLabel: string; strategyLabel: string; signatureLabel: string;
      notSelfLabel: string; centersTitle: string;
      recalculate: string; error: string;
      emptyTitle: string; emptySubtitle: string; emptyCta: string;
    };
    vedicAstrology: {
      title: string; subtitle: string; intro: string;
      consultCta: string; loading: string; addBirthTime: string;
      keyPositions: string; ascLabel: string; moonLabel: string; sunLabel: string;
      nakshatraLabel: string; dashaLabel: string; yogasLabel: string;
      newConsult: string; error: string;
      emptyTitle: string; emptySubtitle: string; emptyCta: string;
    };
    astromatch: {
      title: string; subtitle: string;
      subjectNameLabel: string; subjectNameOptional: string; subjectNamePlaceholder: string;
      cameraBtn: string; noConsent: string; newAnalysis: string;
      errorMsg: string; errorRetry: string;
      loading1: string; loading2: string; loading3: string; loading4: string;
    };
    quiromancy: {
      title: string; subtitle: string;
      handSelectorLabel: string; rightHand: string; leftHand: string;
      rightHandHint: string; leftHandHint: string;
      instructions: string; handTypeLabel: string;
      cameraBtn: string; noConsent: string; newAnalysis: string;
      errorMsg: string; errorRetry: string;
      loading1: string; loading2: string; loading3: string; loading4: string;
    };
    startAstral: {
      tabTalentos: string; tabDesafios: string; tabAmbientes: string;
      tabLideranca: string; tabAreas: string; tabCaminhos: string; tabCiclos: string;
      tabVocacional: string; tabAtual: string; tabAlmejada: string; tabTransicao: string;
    };
    readings: {
      title: string; subtitle: string;
      emptyAll: string; emptyFilter: string; reading: string;
    };
    notFound: { title: string; body: string; back: string; };
    servicos: {
      heroCtaStart: string;
      heroCtaAccess: string;
      heroBadgeFree: string;
      heroBadgeMonthly: string;
      heroBadgeAnnual: string;
      tierFree: string;
      tierMonthly: string;
      tierAnnual: string;
      benefitsTitle: string;
      forWhoTitle: string;
      previewTitle: string;
      previewSubtitle: string;
      previewUnlock: string;
      plansTitle: string;
      plansRecommended: string;
      testimonialsTitle: string;
      faqTitle: string;
      finalCtaTitle: string;
      finalCtaAnonDesc: string;
      finalCtaCreateAccount: string;
      finalCtaHaveAccount: string;
      comingSoonBtn: string;
      comingSoonBadge: string;
      comingSoonDesc: string;
    };
    profile: {
      title: string; subtitle: string;
      planSection: string; currentPlan: string;
      planFree: string; planMonthly: string; planAnnual: string;
      planFreeFull: string; planMonthlyFull: string; planAnnualFull: string;
      cancelCta: string; cancelPrompt: string;
      cancelReasonPricey: string; cancelReasonUnused: string; cancelReasonPause: string;
      cancelReasonOtherPlatform: string; cancelReasonMisc: string;
      cancelConfirmCta: string; cancelling: string; cancelError: string; cancelBack: string;
      accountSection: string;
      nameLabel: string; emailLabel: string; planLabel: string;
      birthSection: string; birthEditBtn: string;
      birthDateLabel: string; birthTimeLabel: string; birthCityLabel: string;
      birthTimeNotSet: string; birthSaveSuccess: string;
      birthDateFormLabel: string; birthTimeFormLabel: string; birthCityFormLabel: string; birthCityPlaceholder: string;
      saveCta: string; savingCta: string; cancelEditCta: string;
      confirmTitle: string; confirmDesc: string; confirmCta: string;
      securitySection: string;
      genderLabel: string; genderM: string; genderF: string; genderNB: string; genderNotSay: string;
      birthLimitError: string;
    };
  };
  shared: {
    privacyTitle: string; privacyDesc: string; privacyConsent: string;
    feedbackQuestion: string; feedbackThanks: string;
    shareWhatsApp: string; shareCopied: string; shareError: string;
    buyCredits: string; newConsult: string; retry: string;
  };
}

const ptBR: Translations = {
  nav: {
    dashboard:    'Início',
    forecast:     'Previsão',
    birthChart:   'Mapa Astral',
    synastry:     'Sinastria',
    questions:    'Pergunte aos Astros',
    astromatch:   'AstroMatch',
    tarot:        'Tarot de Marselha',
    lenormand:    'Tarot Cigano',
    numerology:   'Numerologia',
    iChing:       'I Ching',
    dreamJournal: 'Diário dos Sonhos',
    moonPhases:   'Fases da Lua',
    agenda:       'Agenda Astrológica',
    retrograde:   'Radar Retrógrado',
    eclipses:     'Eclipse Insight',
    astroPet:     'Astro Pet',
    astroCoach:   'Astro Coach',
    startAstral:  'Rota Profissional',
    empresas:     'Empresas',
    astrocartografia: 'Astrocartografia',
    wallet:         'Carteira',
    readings:       'Leituras',
    settings:       'Configurações',
    signOut:        'Sair',
    quiromancy:     'Quiromancia',
    vedicAstrology: 'Astrologia Védica',
    humanDesign:    'Design Humano',
    blog:           'Blog',
    pricing:        'Planos',
  },
  credits: {
    questions:  'Créditos de perguntas',
    synastry:   'Créditos de sinastria',
    astromatch: 'Créditos AstroMatch',
  },
  home: {
    heroBadge:       'Personalizado para você. Não para o seu signo.',
    heroHeadline1:   'Segredo',
    heroHeadline2:   'Astral.',
    heroSubheadline: 'Astrologia, tarô, I Ching, numerologia e muito mais, revelados para você especificamente.',
    heroCta1:        'Descubra seu Segredo Astral →',
    heroCta2:        'Criar conta',
    heroSocialProof: '✦ Seu mapa natal em minutos, é grátis',
    heroScrollHint:  'Ver previsões dos signos',

    signForecastTitle:    'Previsão do dia',
    signForecastSubtitle: 'Selecione seu signo e consulte o que os astros reservam para hoje.',
    forecastToday:        'Previsão de hoje',
    forecastWeek:         'Previsão desta semana',
    forecastMonth:        'Previsão deste mês',
    consultingStars:      'Calculando a previsão para {sign}...',
    starsMoving:          'Não foi possível carregar a previsão. Tente novamente em alguns instantes.',
    seeFullForecast:      'Ver previsão completa ✦',

    featureTitle:    'Tudo que você precisa, num só lugar',
    featureSubtitle: 'Da previsão diária ao mapa astral completo, a tradição de 3.000 anos ao alcance do seu dia.',
    startFree:       'Começar gratuitamente ✦',

    feat: {
      birthChartTitle:    'Mapa Astral',
      birthChartDesc:     'Descubra seus planetas, casas e aspectos com interpretação completa em português.',
      birthChartBadge:    'Premium',
      forecastTitle:      'Previsão Personalizada',
      forecastDesc:       'Previsões diárias, semanais e mensais calculadas para o seu mapa natal.',
      synastryTitle:      'Sinastria',
      synastryDesc:       'Compare seu mapa com o de alguém especial e veja a compatibilidade completa.',
      synastryBadge:      'Premium',
      questionsTitle:     'Pergunte aos Astros',
      questionsDesc:      'Faça qualquer pergunta e receba uma resposta astrológica personalizada.',
      astromatchTitle:    'AstroMatch',
      astromatchDesc:     'Envie uma foto e descubra a personalidade astrológica através da fisiognomia.',
      astromatchBadge:    'Exclusivo',
      moreTitle:          'Tarot, I Ching e mais',
      moreDesc:           'Tiragem de Tarot, I Ching, Numerologia, Diário dos Sonhos e Fases da Lua.',
    },

    premiumBadge:   '✦ Plano Premium',
    premiumTitle1:  'Mergulhe fundo',
    premiumTitle2:  'nos seus astros',
    premiumDesc:    'Com o Professya Premium você tem acesso ao mapa astral completo, sinastria ilimitada, previsões personalizadas e muito mais, por menos de R$ 1 por dia.',
    premiumF1:      'Mapa astral completo com interpretação',
    premiumF2:      'Previsões diárias, semanais e mensais',
    premiumF3:      'Sinastria de relacionamentos',
    premiumF4:      'Perguntas ilimitadas aos astros',
    premiumF5:      'AstroMatch por foto',
    premiumF6:      'Acesso a Tarot, I Ching e Numerologia',
    premiumPrice:   'R$ 24,90',
    premiumPer:     '/mês',
    premiumCta:     'Assinar agora ✦',
    premiumCancel:  'Cancele quando quiser. Sem fidelidade.',

    demoLabel1: 'Mapa Astral',
    demoSub1:   'Sol em Áries · Lua em Touro · ASC Gêmeos',
    demoLabel2: 'Sinastria',
    demoSub2:   'Compatibilidade 87% ✦ Venus em harmonia',
    demoLabel3: 'Previsão de hoje',
    demoSub3:   '"Vênus favorece conexões profundas..."',

    servicesTitle:    'Nossos Serviços',
    servicesSubtitle: 'Da previsão diária ao mapa natal completo, tudo para seu autoconhecimento astrológico.',
    servicesCta:      'Acessar todos os serviços ✦',
    badgePlan:        'Plano',
    badgeCredits:     'Créditos',
    badgeAvulso:      'Avulso',
    badgeNew:         'Novo ✦',
    svc: {
      birthChart:  { name: 'Mapa Astral',           subtitle: 'Seu mapa natal completo',                      description: 'Descubra a posição exata de todos os planetas, casas e aspectos no momento do seu nascimento. Não é um horóscopo genérico, é o mapa único que só você possui.' },
      forecast:    { name: 'Previsão Personalizada', subtitle: 'Diária, semanal, mensal e anual',              description: 'Previsões calculadas para o SEU mapa natal, não para o seu signo. Saiba exatamente quais planetas estão ativando sua vida agora e o que esperar nos próximos meses.' },
      synastry:    { name: 'Sinastria',              subtitle: 'Compatibilidade profunda entre dois mapas',    description: 'Analise a conexão real entre dois mapas natais. Descubra os aspectos que criam atração, tensão, missão kármica e potencial de longo prazo em qualquer relação.' },
      astroMatch:  { name: 'AstroMatch',             subtitle: 'Compatibilidade antes do primeiro encontro',  description: 'Informe o nome, signo e algumas características de alguém e descubra o potencial astrológico dessa conexão antes de se envolver. Economize tempo e energia.' },
      astrocartografia: { name: 'Astrocartografia',    subtitle: 'Onde no mundo você prospera',                 description: 'Descubra se uma cidade é boa para trabalho, amor, dinheiro, saúde e qualidade de vida segundo seu mapa natal. Analise qualquer local do mundo ou detecte onde você está agora.' },
      questions:   { name: 'Pergunte aos Astros',    subtitle: 'Respostas diretas do oráculo',                description: 'Faça qualquer pergunta e receba uma resposta personalizada baseada nos trânsitos planetários ativos no seu mapa natal neste exato momento.' },
      tarot:       { name: 'Tarot de Marselha',       subtitle: '4 tipos de tiragem interpretados',            description: 'Tiragens de 1, 3, 7 e 10 cartas com interpretação profunda baseada na tradição do Tarot de Marselha, aliada à posição dos seus planetas no momento da consulta.' },
      lenormand:   { name: 'Tarot Cigano',         subtitle: 'Lenormand, O oráculo das 36 cartas',         description: 'O Tarot Cigano revela padrões ocultos da sua vida através das 36 cartas de Lenormand. Tiragens de 1, 3, 5 ou 9 cartas com interpretação personalizada e simbólica.' },
      numerology:  { name: 'Numerologia',            subtitle: 'Os números que regem sua vida',               description: 'Número de Destino, Alma, Personalidade e Ano Pessoal calculados a partir do seu nome completo e data de nascimento. Descubra os ciclos que governam sua jornada.' },
      astroPet:    { name: 'Astro Pet',              subtitle: 'O mapa natal do seu animal',                  description: 'Calcule o mapa natal do seu pet e descubra sua personalidade astrológica. Analise também a compatibilidade entre você e seu animal de estimação.' },
      startAstral: { name: 'Rota Profissional',        subtitle: 'Mapa vocacional e transição de carreira',     description: 'Análise completa do seu Meio do Céu, Saturno, Júpiter e Nodo Norte para revelar sua vocação, talentos naturais e o caminho profissional mais alinhado com quem você é. Inclui orientação para transição de carreira.' },
      retrograde:  { name: 'Radar Retrógrado',       subtitle: 'Impacto real no seu mapa',                    description: 'Saiba exatamente como Mercúrio, Vênus, Marte e outros planetas retrógrados afetam o SEU mapa natal, não uma previsão genérica por signo.' },
      eclipse:     { name: 'Eclipse Insight',        subtitle: 'Eclipses que ativam sua vida',                description: 'Descubra quais casas e planetas do seu mapa natal são ativados pelos eclipses solares e lunares, e o que isso significa para os próximos 6 meses da sua vida.' },
    },
  },
  auth: {
    email:            'E-mail',
    password:         'Senha',
    confirmPassword:  'Confirmar senha',
    signIn:           'Entrar',
    createAccount:    'Criar conta',
    forgotPassword:   'Esqueci minha senha',
    resetPassword:    'Redefinir senha',
    noAccount:        'Não tem conta?',
    hasAccount:       'Já tem conta?',
    orContinue:       'ou continue com',
    sendReset:        'Enviar link de redefinição',
    backToLogin:      'Voltar ao login',
    checkEmail:       'Verifique seu e-mail para o link de redefinição.',
    signInTitle:      'Entre na sua conta',
    createTitle:      'Crie sua conta gratuita',
    name:             'Nome',
    namePlaceholder:  'Seu nome',
    showPassword:     'Mostrar senha',
    hidePassword:     'Ocultar senha',
    createFree:       'Criar conta grátis',
    createCta:        'Criar conta ✦',
    agreeText:        'Ao criar conta você concorda com nossos',
    terms:            'Termos',
    privacyPolicy:    'Política de Privacidade',
    biometricTitle:   'Quer entrar mais rápido?',
    biometricDesc:    'Ative o Face ID / Touch ID para entrar no Professya sem digitar a senha.',
    biometricEnable:  'Ativar Face ID / Touch ID',
    biometricSkip:    'Agora não',
    continueGoogle:   'Continuar com Google',
    continueApple:    'Continuar com Apple',
    oauthError:       'Não foi possível autenticar. Tente novamente.',
  },
  common: {
    loading:      'Carregando...',
    error:        'Erro',
    retry:        'Tentar novamente',
    save:         'Salvar',
    cancel:       'Cancelar',
    back:         'Voltar',
    close:        'Fechar',
    confirm:      'Confirmar',
    language:     'Idioma',
  },
  dashboard: {
    cosmicBrief:       '✦ Breve Cósmico',
    consultingStars:   'Calculando sua análise. Isso leva alguns instantes.',
    starsMoving:       'Não foi possível carregar seu painel. Tente novamente em alguns instantes.',
    completeBanner:    'Complete seu perfil',
    completeBannerSub: 'Adicione sua data de nascimento para leituras personalizadas.',
    addData:           'Adicionar dados',
    quickAccess:       'Acesso rápido',
    continueJourney:   'Continuando sua jornada',
    seeAll:            'Ver todas',
    greetingMorning:   'Bom dia',
    greetingAfternoon: 'Boa tarde',
    greetingEvening:   'Boa noite',
    errorTitle:        'Algo não saiu como planejado',
    errorSubtitle:     'Não conseguimos carregar seu perfil. Tente atualizar a página.',
    reload:            'Atualizar',
    suggBirthChartDesc: 'Descubra seus planetas e casas astrológicas.',
    suggForecastTitle:  'Previsão da semana',
    suggForecastDesc:   'O que os astros reservam para você esta semana.',
    suggQuestionsDesc:  'Faça sua primeira pergunta com 1 crédito gratuito.',
    premiumBadge:        'Premium ativo ✦',
    premiumWelcomeTitle: 'Professya Premium ativo',
    premiumWelcomeDesc:  'Acesso completo liberado.',
    premiumClose:        'Fechar',
    premiumStep1:        'Mapa Natal',
    premiumStep2:        'Previsão',
    premiumStep3:        'Sinastria',
    premiumStep4:        'AstroMatch',
    premiumStep5:        'Tarô',
    renewalTitle:        'Sua assinatura expira {when}',
    renewalToday:        'hoje',
    renewalTomorrow:     'amanhã',
    renewalDays:         'em {days} dias',
    renewalDesc:         'Renove agora para não perder o acesso Premium.',
    renewalCta:          'Renovar ✦',
    tierPremium:         'Premium',
    streakSingular:      'dia consecutivo',
    streakPlural:        'dias consecutivos',
    creditQuestionsSingular: 'pergunta',
    creditQuestionsPlural:   'perguntas',
    creditSynastry:          'sinastria',
  },
  layout: {
    navSigns:      'Signos',
    navPlans:      'Planos',
    navBlog:       'Blog',
    navMyAccount:  'Minha Conta',
    navSignIn:     'Entrar',
    navStartFree:  'Começar grátis',
    footerTagline: 'Astrologia e esoterismo para o seu dia a dia.',
    footerProduct: 'Produto',
    footerLegal:   'Legal',
    footerRights:  'Todos os direitos reservados.',
    footerMotto:   'Segredo Astral',
    footerSignos:  'Signos',
    footerBirthChart: 'Mapa Astral',
    footerSynastry:   'Sinastria',
    footerQuestions:  'Perguntas',
    footerPrivacy:    'Privacidade',
    footerTerms:      'Termos de uso',
    footerLgpd:       'LGPD',
    footerBrandTagline:  'Astrologia personalizada para quem você é, não para o seu signo.',
    footerServices:      'Serviços',
    footerOracles:       'Oráculos',
    footerForecast:      'Previsão',
    footerAstroMatch:    'AstroMatch',
    footerAstrocartografia: 'Astrocartografia',
    footerStartAstral:   'Rota Profissional',
    footerTarot:         'Tarô',
    footerIChing:        'I Ching',
    footerNumerology:    'Numerologia',
    footerAstroPet:      'Astro Pet',
    footerPrivacyFull:   'Política de Privacidade',
    footerTermsFull:     'Termos de Uso',
    footerLgpdFull:      'LGPD',
    footerCancellation:  'Cancelamento',
    footerBusiness:      'Para Empresas',
    footerContact:       'Contato',
    footerCopyright:     '© {year} Professya. Todos os direitos reservados.',
    footerDisclaimer:    'As leituras têm caráter reflexivo e de entretenimento.',
    footerNewsletterDesc: 'Novidades astrológicas no seu email. Sem spam.',
  },
  forecast: {
    title:          'Previsão',
    emptyTitle:     'Data de nascimento necessária',
    emptySubtitle:  'Adicione sua data de nascimento para receber previsões personalizadas.',
    emptyCta:       'Adicionar dados',
    starsMoving:    'Não foi possível carregar a previsão. Tente novamente em alguns instantes.',
    periodToday:    'Hoje',
    periodWeek:     'Esta Semana',
    periodMonth:    'Este Mês',
    periodYear:     'Este Ano',
    loadingDaily:   'Calculando a previsão de hoje...',
    loadingWeekly:  'Calculando a previsão desta semana...',
    loadingMonthly: 'Calculando a previsão deste mês...',
    loadingAnnual:  'Calculando a previsão anual...',
    skyNow:              'Céu Agora',
    transitShort:        'Hoje & Esta Semana',
    transitMedium:       'Em Vigor Há Mais de 30 Dias',
    transitMediumBadge:  'Médio prazo',
    transitLong:         'Transformações de Fundo',
    transitLongBadge:    'Longo prazo',
    transitApproaching:  '↗ Entrando',
    transitPeak:         '◉ No pico',
    transitSeparating:   '↘ Saindo',
    transitLongTermChip: '⟳ Longo prazo',
    transitRetrograde:   '® Retrógrado',
    illumination:        'iluminação',
    regenerateTitle:     'Gerar nova previsão',
    regenerateCta:       '↺ Regenerar',
    stillThinking:       'Calculando sua análise. Isso leva alguns instantes.',
  },
  tabs: {
    home:      'Início',
    forecast:  'Previsão',
    questions: 'Perguntar',
    match:     'Match',
    wallet:    'Carteira',
    ariaLabel: 'Navegação principal',
    map:       'Mapa',
    atlas:     'Local',
    profile:   'Perfil',
    search:    'Buscar',
    today:     'Hoje',
    me:        'Eu',
  },
  pages: {
    onboarding: {
      stepOf: 'Passo {step} de {total}',
      welcomeTitle: 'Seu mapa natal está esperando por você.',
      welcomeText: 'Seu mapa natal está esperando por você.\nPara começar, precisamos da sua data, hora e local de nascimento.',
      welcomeCta: 'Começar',
      birthDataTitle: 'Seus dados de nascimento',
      birthDataDesc: 'A hora define seu Ascendente e as casas astrológicas, os dois elementos que mais individualizam seu mapa.\nSe não souber a hora exata, informe a aproximada.',
      birthDateLabel: 'Data de nascimento',
      birthTimeLabel: 'Horário de nascimento',
      birthCityLabel: 'Cidade de nascimento',
      optional: '(opcional)',
      youAreSign: 'Signo solar: {sign}',
      backBtn: 'Voltar',
      continueBtn: 'Continuar',
      skipNow: 'Pular por agora',
      skipSetup: 'Pular configuração →',
      firstReadingTitle: 'Mapa calculado.',
      firstReadingDesc: 'Seu mapa natal está pronto para análise.',
      firstReadingDesc2: 'Seu mapa natal está pronto para análise.',
      previewLabel: 'Prévia do seu painel:',
      previewFeat1Label: 'Previsão de hoje',
      previewFeat1Desc: 'Calculada para o seu mapa natal',
      previewFeat2Label: 'Mapa Astral',
      previewFeat2Desc: 'Sol, Lua, Ascendente e mais 8 planetas',
      previewFeat3Label: 'Pergunte aos Astros',
      previewFeat3Desc: '1 pergunta gratuita na conta nova',
      viewDashboard: 'Ver meu painel',
      upgradeTitle: 'Aprofunde sua jornada',
      upgradeDesc: 'Com o Premium você desbloqueia o mapa astral completo, sinastria, previsões personalizadas e muito mais, por menos de R$ 1 por dia.',
      upgradeF1: 'Mapa astral completo',
      upgradeF2: 'Sinastria de relacionamentos',
      upgradeF3: 'Previsões diárias personalizadas',
      upgradeF4: 'Perguntas ilimitadas aos astros',
      upgradeF5: 'AstroMatch por foto',
      upgradeCta: 'Assinar Premium',
      upgradeFreeCta: 'Continuar com a conta gratuita',
    },
    birthChart: {
      title: 'Mapa Astral',
      houseSystem: 'Cálculo Preciso',
      howToRead: 'Como ler meu mapa',
      calculating: 'Calculando seus planetas e casas astrológicas...',
      planetPositions: 'Posições Planetárias',
      planet: 'Planeta', sign: 'Signo', degree: 'Grau', house: 'Casa',
      showAll: 'Ver todos os planetas ({n} mais)',
      showLess: 'Mostrar menos',
      interpretation: 'Interpretação ✦',
      calculateCta: 'Calcular meu mapa astral',
      retry: '↺ Tentar novamente',
      starsMoving: 'Não foi possível calcular seu mapa. Tente novamente em alguns instantes.',
      emptyTitle: 'Dados de nascimento necessários',
      emptySubtitle: 'Para calcular seu mapa astral, precisamos da sua data de nascimento. Adicione em Perfil.',
      emptyCta: 'Ir para Perfil',
      guideTitle: 'Como ler seu mapa',
      guideCta: 'Entendido ✦',
    },
    synastry: {
      title: 'Compatibilidade Astrológica',
      subtitle: 'Sinastria',
      partnerDataTitle: 'Dados do parceiro(a)',
      partnerNameLabel: 'Nome',
      partnerNamePlaceholder: 'Nome da pessoa',
      partnerSignLabel: 'Signo solar',
      selectSign: 'Selecione o signo',
      partnerDateLabel: 'Data de nascimento',
      autoAnalyzeHint: 'A análise inicia automaticamente ao preencher este campo',
      analyzeCta: 'Analisar compatibilidade (1 crédito)',
      inviteText: 'Prefere que a outra pessoa preencha os dados dela?',
      generateLink: 'Gerar link de convite via WhatsApp',
      linkGenerated: 'Link gerado:',
      copyBtn: 'Copiar',
      compatibility: 'Compatibilidade',
      noCreditsMsg: 'Você não tem créditos de sinastria.',
      buyLink: 'Comprar →',
      calculating: 'Calculando a sinastria entre {partner} e {user}...',
      newAnalysis: 'Nova sinastria',
      errorMsg: 'Não foi possível gerar a análise de sinastria. Tente novamente.',
      emptyTitle: 'Dados de nascimento necessários',
      emptySubtitle: 'Adicione sua data de nascimento para fazer sinastria.',
      emptyCta: 'Ir para Perfil',
      tabScore: 'Score', tabAnalise: 'Análise', tabAspectos: 'Aspectos',
      tabCasas: 'Casas', tabComposto: 'Composto', tabDavison: 'Davison',
      tabTransitos: 'Trânsitos', tabProgressoes: 'Progressões',
      scoreLove: 'Amor e Química', scoreCommunication: 'Comunicação', scoreValues: 'Valores',
      scoreLongTerm: 'Longo Prazo', scoreGrowth: 'Crescimento', scoreRoutine: 'Rotina', scoreFamily: 'Família',
    },
    tarot: {
      title: 'Tarot de Marselha',
      subtitle: 'Tradição clássica dos Arcanos Maiores e Menores',
      restart: 'Recomeçar',
      intentionMsg: 'Concentre-se em uma pergunta...',
      loading: 'Preparando sua leitura...',
      generalReading: '✦ Leitura Geral',
      reversed: 'Invertida',
      spreadSingle: 'Carta do Dia',
      spreadSingleDesc: '1 carta, foco e energia do momento',
      spreadThree: 'Passado · Presente · Futuro',
      spreadThreeDesc: '3 cartas, linha do tempo',
      spreadHorseshoe: 'Ferradura',
      spreadHorseshoeDesc: '7 cartas, visão ampla da situação',
      spreadCeltic: 'Cruz Celta',
      spreadCelticDesc: '10 cartas, análise profunda',
    },
    lenormand: {
      title: 'Tarot Cigano',
      subtitle: 'Lenormand, O oráculo das 36 cartas',
      restart: 'Nova leitura',
      intentionMsg: 'Respire fundo e concentre-se na sua consulta...',
      loading: 'Preparando sua leitura...',
      readingTitle: '✦ Sua Leitura',
      subscriptionRequired: 'Esta consulta está disponível para assinantes mensais ou anuais.',
      spreadSingle: 'Carta do Momento',
      spreadSingleDesc: '1 carta, a mensagem essencial',
      spreadThree: 'Linha do Tempo',
      spreadThreeDesc: '3 cartas, passado, presente e caminho',
      spreadFive: 'Cruz',
      spreadFiveDesc: '5 cartas, situação e conselho',
      spreadNine: 'Quadrado',
      spreadNineDesc: '9 cartas, leitura completa',
      questionLabel: 'Sua consulta (opcional)',
      questionPlaceholder: 'O que deseja compreender? Deixe em branco para uma leitura geral.',
      questionCta: 'Revelar as cartas',
    },
    questions: {
      title: 'Pergunte aos Astros',
      questionLabel: 'Sua pergunta',
      questionPlaceholder: 'Escreva sua pergunta para os astros...',
      showExamples: 'Ver exemplos de perguntas',
      hideExamples: 'Ocultar exemplos',
      disclaimer: 'Respostas de caráter reflexivo · Consulte profissionais para decisões importantes',
      submitCta: 'Perguntar (1 crédito)',
      submitLoading: 'Calculando sua resposta...',
      answerTitle: '✦ Resposta',
      historyTitle: 'Histórico de perguntas',
      noCreditsTitle: 'Você não tem créditos suficientes.',
      noCreditsDesc: 'Seus créditos acabaram. Escolha um pacote abaixo para continuar.',
      loading: 'Consultando o mapa...',
      emptyTitle: 'Complete seu perfil primeiro',
      emptySubtitle: 'Adicione sua data de nascimento para fazer perguntas personalizadas aos astros.',
      emptyCta: 'Ir para Perfil',
    },
    numerology: {
      title: 'Numerologia',
      subtitle: 'Os números que regem sua jornada',
      intro: 'Calcule seu mapa numerológico completo baseado no seu nome e data de nascimento.',
      calculateCta: 'Calcular numerologia',
      calculating: 'Calculando sua numerologia...',
      lifePathLabel: 'Caminho de Vida',
      destinyLabel: 'Destino',
      soulLabel: 'Alma',
      personalityLabel: 'Personalidade',
      newConsult: 'Nova consulta',
      error: 'Não foi possível calcular sua numerologia. Tente novamente.',
      emptyTitle: 'Dados necessários',
      emptySubtitle: 'Adicione seu nome e data de nascimento no perfil para calcular sua numerologia.',
      emptyCta: 'Ir para Perfil',
      tabSinteseGeral: 'Síntese Geral', tabCaminhoDeVida: 'Caminho de Vida',
      tabDestino: 'Número do Destino', tabAlma: 'Número da Alma', tabPersonalidade: 'Personalidade',
    },
    iching: {
      title: 'I Ching',
      subtitle: 'O Livro das Mutações',
      intro: 'O I Ching consulta os padrões de mutação do universo para revelar a essência de sua situação.',
      questionLabel: 'Sua pergunta',
      questionPlaceholder: 'O que deseja compreender?',
      throwingCoins: 'Lançando as moedas...',
      consultCta: 'Consultar o oráculo ✦',
      throwingMsg: 'Lançando as moedas...',
      interpretingMsg: 'Interpretando os hexagramas...',
      hexagramLabel: 'Hexagrama {n}, {name}',
      transformsInto: 'Transforma-se em: Hexagrama {n}',
      newConsult: 'Nova consulta',
      error: 'Não foi possível consultar o I Ching. Tente novamente.',
    },
    dreamJournal: {
      title: 'Diário dos Sonhos',
      subtitle: 'Desvende as mensagens do inconsciente',
      dreamLabel: 'Descreva seu sonho',
      dreamPlaceholder: 'Descreva com detalhes o que você sonhou... Pessoas, lugares, sensações, cores...',
      interpretCta: 'Interpretar meu sonho ✦',
      loading: 'Interpretando seu sonho...',
      symbolsTitle: 'Símbolos identificados',
      interpretationTitle: 'Interpretação',
      guidanceTitle: 'Orientação',
      historyTitle: 'Diário',
      newEntry: 'Registrar outro sonho',
      error: 'Não foi possível interpretar o sonho. Tente novamente.',
    },
    moonPhases: {
      title: 'Fases da Lua',
      subtitle: 'Calendário lunar e energias do ciclo',
      illuminated: '{n}% iluminada',
      upcomingPhases: 'Próximas fases',
      ritualsFor: 'Rituais para {phase}',
    },
    humanDesign: {
      title: 'Design Humano',
      subtitle: 'Seu tipo e estratégia de vida',
      intro: 'Descubra seu tipo de Design Humano, estratégia de vida e autoridade interna para tomar decisões com clareza.',
      calculateCta: 'Calcular Design Humano',
      calculating: 'Calculando seu Design Humano...',
      birthTimeWarning: '✦ Hora de nascimento recomendada',
      birthTimeWarningDesc: 'O Design Humano é mais preciso com sua hora de nascimento. Sem ela, utilizaremos um cálculo aproximado.',
      addBirthTime: 'Adicionar hora de nascimento →',
      profileLabel: 'Perfil',
      authorityLabel: 'Autoridade',
      strategyLabel: 'Estratégia',
      signatureLabel: 'Assinatura',
      notSelfLabel: 'Não-Self',
      centersTitle: '✦ Centros',
      recalculate: 'Recalcular',
      error: 'Não foi possível calcular seu Design Humano. Tente novamente.',
      emptyTitle: 'Data de nascimento necessária',
      emptySubtitle: 'Adicione sua data de nascimento para calcular seu Design Humano.',
      emptyCta: 'Ir para Perfil',
    },
    vedicAstrology: {
      title: 'Astrologia Védica',
      subtitle: 'Jyotish, a Ciência da Luz',
      intro: 'A astrologia védica (Jyotish) é um sistema milenar da Índia que usa o zodíaco sideral, revelando camadas profundas do destino, karma e propósito.',
      consultCta: 'Consultar Jyotish',
      loading: 'Calculando o mapa védico...',
      addBirthTime: '✦ Adicionar sua hora de nascimento torna a leitura muito mais precisa.',
      keyPositions: '✦ Posições chave',
      ascLabel: 'Ascendente (Lagna)',
      moonLabel: 'Signo da Lua',
      sunLabel: 'Signo do Sol',
      nakshatraLabel: 'Nakshatra',
      dashaLabel: 'Dasha atual',
      yogasLabel: 'Yogas presentes',
      newConsult: 'Nova consulta',
      error: 'Não foi possível calcular a astrologia védica. Tente novamente.',
      emptyTitle: 'Data de nascimento necessária',
      emptySubtitle: 'Adicione sua data de nascimento para acessar a astrologia védica.',
      emptyCta: 'Ir para Perfil',
    },
    astromatch: {
      title: 'AstroMatch',
      subtitle: 'Análise astrológica por fisiognomia',
      subjectNameLabel: 'Nome da pessoa',
      subjectNameOptional: '(opcional)',
      subjectNamePlaceholder: 'Ex: João',
      cameraBtn: 'Câmera / Galeria',
      noConsent: '↑ Aceite os termos acima para habilitar o envio de foto',
      newAnalysis: 'Nova análise',
      errorMsg: 'Não foi possível processar a análise. Tente novamente ✦',
      errorRetry: 'Tentar com outra foto',
      loading1: 'Analisando traços faciais...',
      loading2: 'Calculando posições planetárias...',
      loading3: 'Calculando a carta natal...',
      loading4: 'Preparando sua análise...',
    },
    quiromancy: {
      title: 'Quiromancia',
      subtitle: 'A leitura das linhas da mão',
      handSelectorLabel: 'Qual mão deseja analisar?',
      rightHand: 'Mão Direita',
      leftHand: 'Mão Esquerda',
      rightHandHint: 'Mão direita, destino e presente',
      leftHandHint: 'Mão esquerda, potencial nato',
      instructions: 'Fotografe a palma da mão aberta, com boa iluminação e fundo claro.',
      handTypeLabel: '✦ Tipo de mão',
      cameraBtn: 'Câmera / Galeria',
      noConsent: '↑ Aceite os termos acima para habilitar o envio de foto',
      newAnalysis: 'Nova análise',
      errorMsg: 'Não conseguimos ler as linhas desta imagem. Certifique-se de que a palma está bem visível e iluminada.',
      errorRetry: 'Tentar com outra foto',
      loading1: 'Analisando as linhas da mão...',
      loading2: 'Identificando os montes...',
      loading3: 'Calculando posições planetárias...',
      loading4: 'Preparando sua leitura...',
    },
    startAstral: {
      tabTalentos: 'Talentos', tabDesafios: 'Desafios', tabAmbientes: 'Ambientes',
      tabLideranca: 'Liderança', tabAreas: 'Áreas Profissionais', tabCaminhos: 'Caminhos Desafiadores', tabCiclos: 'Ciclos',
      tabVocacional: 'Mapa Vocacional', tabAtual: 'Carreira Atual', tabAlmejada: 'Cargo Almejado', tabTransicao: 'Transição',
    },
    readings: {
      title: 'Leituras',
      subtitle: 'Seu histórico de consultas',
      emptyAll: 'Nenhuma análise gerada ainda.\nComece pelo Mapa Astral, é a base de tudo.',
      emptyFilter: 'Nenhuma leitura deste tipo ainda.',
      reading: 'Leitura',
    },
    notFound: {
      title: 'Página não encontrada',
      body:  'Esta página não existe ou foi movida.',
      back:  'Voltar ao início',
    },
    servicos: {
      heroCtaStart:          'Começar agora',
      heroCtaAccess:         'Acessar',
      heroBadgeFree:         'Disponível em todos os planos',
      heroBadgeMonthly:      'Disponível a partir do Plano Mensal',
      heroBadgeAnnual:       'Exclusivo do Plano Anual',
      tierFree:              'Gratuito',
      tierMonthly:           'Mensal',
      tierAnnual:            'Anual',
      benefitsTitle:         'O que você vai descobrir',
      forWhoTitle:           'Este serviço é para você se...',
      previewTitle:          'Um gosto do que você vai receber',
      previewSubtitle:       'Exemplo ilustrativo, a sua análise é sempre única',
      previewUnlock:         '✦ Desbloqueie a sua análise completa',
      plansTitle:            'Escolha seu plano e comece agora',
      plansRecommended:      '✦ RECOMENDADO PARA ESTE SERVIÇO',
      testimonialsTitle:     'O que nossas usuárias dizem',
      faqTitle:              'Perguntas frequentes',
      finalCtaTitle:         'Comece agora e receba sua análise em instantes',
      finalCtaAnonDesc:      'Crie sua conta em menos de um minuto e acesse sua primeira análise.',
      finalCtaCreateAccount: 'Criar conta gratuita',
      finalCtaHaveAccount:   'Já tenho conta',
      comingSoonBtn:         'Em breve ✦',
      comingSoonBadge:       'Lançamento em breve',
      comingSoonDesc:        'Estamos dando os últimos toques. Em breve você poderá acessar este serviço pela Professya.',
    },
    profile: {
      title:    'Minha Conta',
      subtitle: 'Gerencie suas informações e segurança.',
      planSection:  'Meu Plano',
      currentPlan:  'Plano atual:',
      planFree:     'Gratuito',
      planMonthly:  'Mensal',
      planAnnual:   'Anual',
      planFreeFull:    'Gratuito',
      planMonthlyFull: 'Professya Mensal',
      planAnnualFull:  'Professya Anual',
      cancelCta:    'Cancelar assinatura',
      cancelPrompt: 'Sentiremos sua falta. Se quiser nos contar o motivo (opcional):',
      cancelReasonPricey:        'Ficou caro',
      cancelReasonUnused:        'Não uso tanto quanto esperava',
      cancelReasonPause:         'Vou fazer uma pausa e voltarei',
      cancelReasonOtherPlatform: 'Encontrei outra plataforma',
      cancelReasonMisc:          'Outro motivo',
      cancelConfirmCta: 'Cancelar minha assinatura',
      cancelling:       'Cancelando...',
      cancelError:      'Não foi possível cancelar. Tente novamente ou entre em contato.',
      cancelBack:       'Voltar',
      accountSection:   'Informações da conta',
      nameLabel:        'Nome:',
      emailLabel:       'Email:',
      planLabel:        'Plano:',
      birthSection:     'Dados de nascimento',
      birthEditBtn:     'Editar',
      birthDateLabel:   'Data:',
      birthTimeLabel:   'Hora:',
      birthCityLabel:   'Cidade:',
      birthTimeNotSet:  'Não informada',
      birthSaveSuccess: 'Dados atualizados. Recalculando seu mapa natal...',
      birthDateFormLabel: 'Data de nascimento',
      birthTimeFormLabel: 'Hora de nascimento (opcional)',
      birthCityFormLabel: 'Cidade de nascimento',
      birthCityPlaceholder: 'Ex: São Paulo, SP',
      saveCta:      'Salvar',
      savingCta:    'Salvando...',
      cancelEditCta: 'Cancelar',
      confirmTitle: 'Recalcular mapa natal?',
      confirmDesc:  'Alterar sua data de nascimento irá recalcular seu mapa natal. Suas leituras anteriores não serão afetadas, mas as novas usarão os dados atualizados.',
      confirmCta:   'Confirmar e recalcular',
      securitySection: 'Segurança',
      genderLabel: 'Gênero:', genderM: 'Masculino', genderF: 'Feminino', genderNB: 'Não-binário', genderNotSay: 'Prefiro não dizer',
      birthLimitError: 'Você atingiu o limite de 2 alterações de dados de nascimento. Entre em contato com o suporte para solicitar uma correção.',
    },
  },
  shared: {
    privacyTitle: 'Sua privacidade é prioridade',
    privacyDesc: 'A foto é processada apenas para análise e nunca é salva nos nossos servidores. Os dados de geolocalização (EXIF) são removidos antes do envio.',
    privacyConsent: '✓ Entendido, a foto não será salva. Aceito prosseguir.',
    feedbackQuestion: 'Esta leitura foi útil?',
    feedbackThanks: 'Obrigado pelo seu feedback!',
    shareWhatsApp: 'Compartilhar Minha Professya ✦',
    shareCopied: 'Texto copiado! Cole no WhatsApp ✦',
    shareError: 'Não foi possível compartilhar. Tente copiar o texto manualmente.',
    buyCredits: 'Comprar créditos ✦',
    newConsult: 'Nova consulta',
    retry: 'Tentar novamente',
  },
};

export default ptBR;
